interface IBasicInputDescriptor
{
	id?: string;
	name: string;
	disabled?: boolean;
 	autocomplete?: boolean;
	readonly?: boolean;
	classes?: string[];
	required?: boolean;
	size?: GridSizing|any;
}

interface IInputDescriptor extends IBasicInputDescriptor
{
	value: string;
	maxlength?: number;
	placeholder?: string;
}

interface IRangedInputDescriptor extends IInputDescriptor
{
	step?: number;
	min?: number;
	max?: number;
 	val?: number;
}

interface ITextareaDescriptor
	extends IBasicInputDescriptor
{
 	maxlength?: number;
	placeholder?: string;
 	cols?: number;
 	rows?: number;
 	resize?: string;								/* both | horizontal | vertical */
}

interface ILabelDescriptor
{
	id?: string;
 	value: string;
	name?: string;
	disabled?: boolean;
	classes?: string[];
}

interface IInputGroupDescriptor
{
	input: BasicInputField;
	before?: Icon|string|InputRadio|InputCheckbox|Button[];
	after?: Icon|string|InputRadio|InputCheckbox|Button[];
	size?: GridSizing|any;
}

abstract class BasicInputField
{
	protected element: JQuery;
	private size: GridSizing|any;

	constructor( element: string, descriptor: IBasicInputDescriptor )
	{

		this.element = $( document.createElement( element ) );

		if ( descriptor.id )
		{
			this.element.attr( 'id', descriptor.id );
		}

		if ( !descriptor.name )
		{
			descriptor.name = Math.ceil( Math.random() * 10000000 ).toString() + "_" + new Date().getTime();
		}

		this.element.attr( 'name', descriptor.name );

		if ( descriptor.readonly )
		{
			this.element.attr( 'readonly', 'readonly' );
		}

		if ( descriptor.disabled )
		{
			this.element.attr( 'disabled', 'disabled' );
		}

		if ( descriptor.required )
		{
			this.element.attr( 'required', 'required' );
		}

	 if ( descriptor.autocomplete )
		{
			this.element.attr( 'autocomplete', 'on' );
		}

		if ( descriptor.classes )
		{
			for ( const i in descriptor.classes )
			{
				if ( descriptor.classes[ i ] === undefined )
				{
					continue;
				}

				this.element.addClass( descriptor.classes[ i ] );
			}
		}
	}

	public Value(): string | number | string[]
	{
		return this.element.val() || '';
	}

	public Name(): string
	{
		return this.element.attr( 'name' ) || '';
	}

	public getElement() : HTMLElement
	{
		if ( this.size )
		{
			const outerElement = ui.$$.div();

			// this.size ist array
			outerElement.addClass( this.size );

			outerElement.append( this.element );

			return outerElement[ 0 ];
		}

		return this.element[ 0 ];
	}

}

class InputField
	extends BasicInputField
{

	constructor(
		type_: string,
		descriptor: IInputDescriptor,
	)
	{
		super( 'input', descriptor );

		this.element.attr( 'type', type_ );

		this.element.attr( 'value', descriptor.value );

		if ( descriptor.placeholder )
		{
			this.element.attr( 'placeholder', descriptor.placeholder );
		}

		if ( descriptor.maxlength && descriptor.maxlength > 0 )
		{
			this.element.attr( 'maxlength', descriptor.maxlength );
		}
	}

}

class InputGroup
{
	private element: JQuery;
	private size: GridSizing|any;

	constructor( descriptor: IInputGroupDescriptor )
	{
		this.element = $( document.createElement( 'div' ) );
		this.element.addClass( 'input-group' );

		if ( descriptor.size )
		{
			for ( const i in descriptor.size )
			{
				$( this.element ).addClass( 'col-' + i + '-' + descriptor.size[i]);
			}
		}

		this.element.append( this.append( descriptor.before ) );

		this.element.append( descriptor.input.getElement() );

		this.element.append( this.append( descriptor.after ) );
	}

	public getElement() : HTMLElement
	{
		if ( this.size )
		{
			const outerElement = $( document.createElement( 'div' ) );

			for ( const i in this.size )
			{
				outerElement.addClass( this.size[ i ] );
			}

			outerElement.append( this.element );

			return outerElement[ 0 ];
		}

		return this.element[ 0 ];
	}

	private append( element: any ) : JQuery
	{
		const container = $( document.createElement( 'span' ) );
		container.addClass( 'input-group-addon' );

		if ( element instanceof Icon )
		{
			container.append( element.getElement() );
		}
		else if ( typeof element === 'string' )
		{
			container.html( element );
		}
		else if ( element instanceof InputRadio )
		{
			container.append( element.getElement() );
		}
		else if ( element instanceof InputCheckbox )
		{
			container.append( element.getElement() );
		}
		else if ( element instanceof Array )
		{
			container.removeClass( 'input-group-addon' );
			container.addClass( 'input-group-btn' );

			for ( const i in element )
			{
				const btn = element[ i ];

				if ( !( btn instanceof Button ) )
				{
					continue;
				}

				container.append( btn.getElement() );
			}
		}
		return container;
	}

}

class InputColor
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'color', descriptor);
		}
}

class InputDate
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'date', descriptor);
		}
}

class InputDateTime
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'datetime-local', descriptor);
		}
}

class InputEmail
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'email', descriptor);
		}
}

class InputFile
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'file', descriptor);
		}
}

class InputHidden
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'hidden', descriptor);
		}
}

class InputMonth
	extends InputField
{
		public constructor( descriptor: IInputDescriptor )
		{
			super( 'month', descriptor);
		}
}

class InputNumber
	extends InputField
{
		constructor( descriptor: IRangedInputDescriptor )
		{
			super( 'number', descriptor);

			if ( descriptor.step )
			{
				this.element.attr( 'step', descriptor.step );
			}
			if ( descriptor.min )
			{
				this.element.attr( 'min', descriptor.min );
			}
			if (descriptor.max )
			{
				this.element.attr( 'max', descriptor.max );
			}
		}
}

class InputPassword
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'password', descriptor);
		}
}

class InputRadio
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'radio', descriptor);
		}
}

class InputRange
	extends InputField
{
		constructor( descriptor: IRangedInputDescriptor )
		{
			super( 'range', descriptor);

			if ( descriptor.step )
			{
				this.element.attr( 'step', descriptor.step );
			}
			if ( descriptor.min )
			{
				this.element.attr( 'min', descriptor.min );
			}
			if ( descriptor.max )
			{
				this.element.attr( 'max', descriptor.max );
			}
			if ( descriptor.val )
			{
	 			this.element.attr( 'value', descriptor.val );
			}
		}
}

class InputSearch
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'search', descriptor);
		}
}

class InputTel
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'tel', descriptor);
		}
}

class InputText
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'text', descriptor);
		}
}

class InputTextarea
	extends BasicInputField
{

		constructor( descriptor: ITextareaDescriptor )
		{

			super( 'textarea', descriptor );

		 if ( descriptor.cols )
			{
				this.element.attr( 'cols', descriptor.cols );
			}

		 if ( descriptor.rows )
			{
				this.element.attr( 'rows', descriptor.rows );
			}

		 if ( descriptor.maxlength )
			{
				this.element.attr( 'maxlength', descriptor.maxlength );
			}

		 if ( descriptor.resize )
			{
				this.element.css( 'resize', descriptor.resize );
				this.element.css( 'overflow', 'auto' );
			}

		 if ( descriptor.classes ) { for ( const i in descriptor.classes ) {
			{
				this.element.addClass( descriptor.classes[ i ] );
			}
			}
		 }

		}

}

class InputTime
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'time', descriptor);
		}
}

class InputUrl
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'url', descriptor);
		}
}

class InputWeek
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'week', descriptor);
		}
}

class InputCheckbox
	extends InputField
{
		constructor( descriptor: IInputDescriptor )
		{
			super( 'checkbox', descriptor);
		}
}

class InputStatic
	extends BasicInputField
{
	constructor( name: string, value: string )
	{
		super( 'p', { name } );

		this.element.addClass( 'form-control-static' );

		this.element.text( value );
	}
}

class InputSelect
	extends BasicInputField
{
	constructor( descriptor: IBasicInputDescriptor, options: { [key: string]: string|number }, _default: number = 0 )
	{
		super( 'select', descriptor );

		let i = 0;
		for ( const o in options )
		{
			const option: JQuery = $( document.createElement( 'option' ) ).attr( 'value', options[ o ] ).text( o );

			if ( _default == i++ )
			{
				option.attr( 'selected', 'selected' );
			}

			this.element.append( option );
		}
	}
}

class InputLabel
{

 	private element: JQuery;

	constructor( descriptor: ILabelDescriptor)
	{

	 	this.element = $( document.createElement( 'label' ) );

		 if ( descriptor.id )
		{
			this.element.attr( 'id', descriptor.id );
		}

		 if ( descriptor.name )
		{
			this.element.attr( 'name', descriptor.name );
		}

		 if ( descriptor.classes ) { for ( const i in descriptor.classes ) {
		{
			this.element.addClass( descriptor.classes[ i ] );
		}
			}
		 }

		 this.element.html( descriptor.value );
	}

 	public getElement() : HTMLElement
	{
		return this.element[ 0 ];
	}

}
